var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 850.393,
    height: 187.11,
    viewBox: "0 0 850.393 187.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec4625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b57059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#9f6e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#666961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#3a6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#1a646a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#07626c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00626d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#007694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56",
    "data-name": "\\uADF8\\uB8F9 56",
    transform: "translate(-963.78 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_40",
    "data-name": "\\uADF8\\uB8F9 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_122",
    "data-name": "\\uD328\\uC2A4 122",
    d: "M986.112,187.11a15.544,15.544,0,0,1-9.932-3.246,14.016,14.016,0,0,1-4.967-10c-1.733-20.545,15.855-31.557,31.373-41.274,4.549-2.847,8.845-5.538,12.454-8.332a80.887,80.887,0,0,0,8.43-7.562,48.424,48.424,0,0,0-1.408-6.106,40.4,40.4,0,0,0-2.617-6.587c-5.4-10.652-15.317-18.284-24.3-24.345-2.338-1.577-4.771-3.052-7.349-4.615-7.513-4.556-15.284-9.266-20.568-16.62-3.629-5.049-4.422-10.362-2.233-14.962,2.574-5.41,8.873-9.049,16.444-9.5a58.009,58.009,0,0,1,31.335,7.117c11.055,6.174,19.538,16.432,24.531,29.665a78.575,78.575,0,0,1,4.447,22.292q1.592-2.375,3.193-4.795,1.413-2.129,2.845-4.274a84.241,84.241,0,0,1-1.487-8.461c-3.019-24.367,4.134-46.668,19.623-61.184a53.79,53.79,0,0,1,37.562-14.3c11.979.369,24.869,4.912,25.129,16.556.218,9.868-11.077,15.291-15.9,17.608-18.4,8.828-31.71,17.852-41.9,28.4-6.511,6.736-12.118,14.548-17.427,22.414,4.765,18.6,15.812,33.173,30.64,48.62.905.944,1.932,1.962,3.027,3.046,7.905,7.841,18.734,18.578,15.1,30.3-2.909,9.4-13.7,11.416-22.088,10.294a48.346,48.346,0,0,1-23.534-9.8c-15.653-12.542-18.791-34.637-19.268-46.692-.149-3.753-.19-7.582-.228-11.285,0-.237-.006-.474-.008-.711-2.538,3.341-5.2,6.589-8.046,9.67a72.26,72.26,0,0,1-2.359,27.945c-4.888,17.193-17.773,38.134-38,40.567A20.912,20.912,0,0,1,986.112,187.11Zm38.053-63.792c-1.891,1.773-3.861,3.469-5.93,5.071-3.815,2.952-8.218,5.709-12.88,8.628-14.949,9.36-30.407,19.039-28.94,36.411a8.807,8.807,0,0,0,3.061,6.388c2.059,1.678,5.088,2.368,8.527,1.959,17.681-2.128,29.151-21.161,33.6-36.813A68.17,68.17,0,0,0,1024.165,123.318Zm17.976-21.593c.061,2.578.089,5.151.116,7.705.038,3.666.08,7.456.224,11.135.444,11.165,3.281,31.577,17.317,42.823a43.057,43.057,0,0,0,20.966,8.7c6.37.853,14.462-.381,16.408-6.664,2.694-8.7-6.836-18.155-13.8-25.055-1.125-1.116-2.184-2.165-3.116-3.137-12.538-13.061-24.618-27.683-30.647-46.588-.109.162-.215.324-.324.488C1046.949,94.657,1044.588,98.214,1042.141,101.725Zm-57.363-62.64q-1.518,0-3.033.091c-5.585.331-10.311,2.9-12.041,6.53-1.354,2.845-.744,6.19,1.758,9.674,4.664,6.489,11.972,10.919,19.037,15.2,2.516,1.526,5.118,3.1,7.561,4.75,9.542,6.437,20.1,14.6,26.041,26.313a45.773,45.773,0,0,1,2.958,7.438h0q.422,1.4.766,2.84c3.188-3.716,6.157-7.664,9.05-11.767-.3-9.454-1.184-18.895-4.455-27.566-4.553-12.067-12.227-21.387-22.2-26.952A52.675,52.675,0,0,0,984.778,39.085ZM1102,5.218a48.514,48.514,0,0,0-32.513,12.915c-14.256,13.363-20.823,34.042-18.012,56.734q.19,1.539.434,3.038a150.822,150.822,0,0,1,15.147-18.949c10.637-11.005,24.426-20.372,43.4-29.477,6.469-3.106,13.066-7.055,12.939-12.786-.229-10.322-16.758-11.353-20.07-11.455Q1102.665,5.217,1102,5.218Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_41",
    "data-name": "\\uADF8\\uB8F9 41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_45",
    "data-name": "\\uC0AC\\uAC01\\uD615 45",
    width: 15.776,
    height: 15.775,
    transform: "translate(1282.456 43.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_123",
    "data-name": "\\uD328\\uC2A4 123",
    d: "M1375.819,71.195a24.167,24.167,0,0,0-12.308-3.263H1319.04v81.6h15.776V83.843h28.831A9.135,9.135,0,0,1,1368,84.931a7.563,7.563,0,0,1,3.127,3.061,8.723,8.723,0,0,1,1.089,4.283V149.53h15.911V92.275a23.435,23.435,0,0,0-3.332-12.24A24.7,24.7,0,0,0,1375.819,71.195Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_124",
    "data-name": "\\uD328\\uC2A4 124",
    d: "M1459.2,125.6a7.962,7.962,0,0,1-1.157,4.216,7.77,7.77,0,0,1-3.126,2.923,9.2,9.2,0,0,1-4.285,1.02h-23.12a9.59,9.59,0,0,1-4.351-1.02,7.216,7.216,0,0,1-3.128-2.923,8.328,8.328,0,0,1-1.088-4.216V91.868a8.337,8.337,0,0,1,1.088-4.217,7.23,7.23,0,0,1,3.128-2.924,9.59,9.59,0,0,1,4.351-1.02h24.344V67.932h-24.208a24.053,24.053,0,0,0-12.376,3.263,24.306,24.306,0,0,0-8.84,8.84,23.547,23.547,0,0,0-3.263,12.1v33.183a23.54,23.54,0,0,0,3.263,12.105,24.3,24.3,0,0,0,8.84,8.84,24.043,24.043,0,0,0,12.376,3.263H1450.5a23.8,23.8,0,0,0,12.24-3.263,24.864,24.864,0,0,0,8.908-8.84,23.187,23.187,0,0,0,3.331-12.105V43.893H1459.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_125",
    "data-name": "\\uD328\\uC2A4 125",
    d: "M1503.767,48.109a31.519,31.519,0,0,0-11.423,11.356,30.066,30.066,0,0,0-4.216,15.572v43.35a30.063,30.063,0,0,0,4.216,15.572,31.519,31.519,0,0,0,11.423,11.356,30.686,30.686,0,0,0,15.776,4.215h40.936V133.754h-41.071a16.143,16.143,0,0,1-7.752-1.971,14.346,14.346,0,0,1-5.713-5.441,14.876,14.876,0,0,1-2.039-7.683V74.765a14.891,14.891,0,0,1,2.039-7.685,14.489,14.489,0,0,1,5.644-5.439,16.033,16.033,0,0,1,7.821-1.973h41.071V43.893h-40.936A30.706,30.706,0,0,0,1503.767,48.109Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_126",
    "data-name": "\\uD328\\uC2A4 126",
    d: "M1594.379,132.394a7.748,7.748,0,0,1-2.993-3.059,8.7,8.7,0,0,1-1.088-4.284V43.893h-15.911v81.158a24.566,24.566,0,0,0,3.128,12.239,24.074,24.074,0,0,0,8.567,8.909,22.214,22.214,0,0,0,11.833,3.331h7.343V133.483h-6.664A8.319,8.319,0,0,1,1594.379,132.394Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_46",
    "data-name": "\\uC0AC\\uAC01\\uD615 46",
    width: 15.776,
    height: 81.599,
    transform: "translate(1620.299 67.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_47",
    "data-name": "\\uC0AC\\uAC01\\uD615 47",
    width: 15.776,
    height: 15.775,
    transform: "translate(1620.299 43.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_127",
    "data-name": "\\uD328\\uC2A4 127",
    d: "M1713.662,71.195a24.17,24.17,0,0,0-12.308-3.263h-44.472v81.6h15.777V83.843h28.831a9.128,9.128,0,0,1,4.352,1.088,7.557,7.557,0,0,1,3.127,3.061,8.713,8.713,0,0,1,1.089,4.283V149.53h15.912V92.275a23.425,23.425,0,0,0-3.333-12.24A24.7,24.7,0,0,0,1713.662,71.195Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_128",
    "data-name": "\\uD328\\uC2A4 128",
    d: "M1790.1,101.795h-25.976V117.57h25.7a24.059,24.059,0,0,0,12.308-3.2,23.777,23.777,0,0,0,8.773-8.839,25.2,25.2,0,0,0,3.263-12.852,24.284,24.284,0,0,0-3.263-12.24,25.079,25.079,0,0,0-8.84-9.112,23.091,23.091,0,0,0-12.241-3.4H1765.35a24.349,24.349,0,0,0-24.344,24.343v32.912a24.348,24.348,0,0,0,24.344,24.343h42.7V133.754h-42.841a8.7,8.7,0,0,1-4.283-1.088,7.62,7.62,0,0,1-3.059-3.059,8.7,8.7,0,0,1-1.088-4.285V92.139a8.714,8.714,0,0,1,1.088-4.284,7.645,7.645,0,0,1,3.059-3.059,8.707,8.707,0,0,1,4.283-1.089H1790.1a7.761,7.761,0,0,1,4.148,1.224,8.372,8.372,0,0,1,3.059,3.332,9.52,9.52,0,0,1,1.088,4.42,9.207,9.207,0,0,1-2.379,6.6A7.808,7.808,0,0,1,1790.1,101.795Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_48",
    "data-name": "\\uC0AC\\uAC01\\uD615 48",
    width: 15.776,
    height: 81.599,
    transform: "translate(1282.456 67.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_129",
    "data-name": "\\uD328\\uC2A4 129",
    d: "M1260.716,43.9h-13.055a1.4,1.4,0,0,0-.155.239l-7.85,14.311-29.962,54.587-30.057-54.587-7.886-14.311a2.469,2.469,0,0,0-.155-.239h-13.844V149.529h15.639V78.992l29.375,53.4a8.065,8.065,0,0,0,4.284,3.8,7.625,7.625,0,0,0,5.3,0,7.545,7.545,0,0,0,4.152-3.8l29.375-53.427v70.561h15.771V43.9Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.f0c1d1d2084409bd72cc6c292241bf67.svg";
export { ForwardRef as ReactComponent };